import React from 'react';
import CustomScrollbar from 'js/common/components/CustomScrollbar';
import { changeHomePage, deleteIC, changeIssueCollectorStatus } from 'js/app/actions/AppActions';
import { GLOBAL_CONSTANTS } from 'js/common/constants/GlobalConstants';
import { getI18NMessage } from 'I18N/I18NHelper';
import { updateIssueCollectorConfig } from '../actions/IssueConfigActions';
import AppHelper from 'js/app/AppHelper';
import { showMessage } from 'js/modules/message/actions/MessageActions';
import { BOARD_MESSAGE_CONSTANT } from 'js/modules/message/constants/MessageConstants';
import EWRHelpPage from '../../EWRHelpPage/EWRHelpPage';


class IssueListingView extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			highlightIC: undefined
		};
		this.updateStatus = this.updateStatus.bind(this);
	}

	componentDidMount() {
        this.props.getIssueListing( this.props.appData.issueList );
	}
	
	render() {
		if ( Object.keys(this.props).length === 0 || !this.props.appData.issueList ) {
			return false;
		}

		const cardTypes = AppHelper.getAppData( 'card_type_list' );
		const headerHeight = this.props.store.getState().appData.appData.headerHeight + 20;

		return (
			<CustomScrollbar style={{ height: 'calc(100% - ' + headerHeight + 'px)', width: '100%' }} className='issue_list_scroll_cnt'>
				{this.props.appData.issueList.length > 0 ? (
				<div className='issue_listing'>
                	<table>
						<thead>
							<tr>
								<td className='bold'>{ getI18NMessage('name') }</td>
								<td className='bold'>{ getI18NMessage('updatedby') }</td>
								<td className='bold'>{ getI18NMessage('cardtype') }</td>
								<td className='bold'>{ getI18NMessage('description') }</td>
								<td className='bold'>{ getI18NMessage('status') }</td>
								<td className='bold'>{ getI18NMessage('action') }</td>
							</tr>
						</thead>
						<tbody>
							{
								this.props.appData.issueList.map( issue => (
									<tr key={ issue.id } className={ this.state.highlightIC === issue.id ? 'highlight_row' : '' }>
										<td>
											<span className='hyperlink' icid={ issue.id } onClick={ this.editIC.bind(this) }>{ issue.name }</span>
										</td>
										<td>{ issue.updatedby }</td>
										<td>{ cardTypes ? cardTypes.filter( cardtype => cardtype.cardType === issue.cardtype )[0].cardTypeName : '' }</td>
										<td>{ issue.description }</td>
										<td className={ issue.status + 'td' }>
											<div className='tg_btn_bar cur_pointer' icid={ issue.id } onClick={ this.updateStatus }></div>
											<span className='circle cur_pointer' icid={ issue.id } onClick={ this.updateStatus }></span>
											{ issue.status === GLOBAL_CONSTANTS.ENABLED ? getI18NMessage('enabled') : getI18NMessage('disabled') }
										</td>
										<td className='action'>
											<span className='icon-edit cur_pointer' onClick={ this.editIC.bind(this) } icid={ issue.id }></span>
											<span className='icon-delete cur_pointer' onClick={ this.onDeleteICClick.bind(this) } icid={ issue.id }></span>
										</td>
									</tr>
								) )
							}
						</tbody>
					</table>
            	</div>) : (<EWRHelpPage></EWRHelpPage>) }
			</CustomScrollbar>
		);
	}

	/* istanbul ignore next */
	updateStatus(event) {
		const icid = event.target.getAttribute('icid');
		const icconfig = this.props.store.getState().appData.appData.issueList.filter( ic => ic.id === icid )[0];

		let status;

		if ( icconfig.status === GLOBAL_CONSTANTS.ENABLED ) {
			status = GLOBAL_CONSTANTS.DIENABLED
		} else {
			status = GLOBAL_CONSTANTS.ENABLED;
		}

		this.props.store.dispatch( changeIssueCollectorStatus(icid, status) );
	}

	/* istanbul ignore next */
	editIC(event) {
		const icid = event.target.getAttribute('icid');
		const icconfig = this.props.store.getState().appData.appData.issueList.filter( ic => ic.id === icid )[0];

		this.props.store.dispatch( updateIssueCollectorConfig(icconfig) );
		this.props.store.dispatch( changeHomePage(GLOBAL_CONSTANTS.EDIT_ISSUE_COLLECTOR) );
	}

	/* istanbul ignore next */
	deleteIC(id) {
		this.props.store.dispatch( deleteIC(id) );
	}

	/* istanbul ignore next */
	onDeleteICClick(event) {
		const icid = event.target.getAttribute('icid');
		const that = this;

		this.setState({
			highlightIC: icid
		});

		this.props.store.dispatch( showMessage({
			type: BOARD_MESSAGE_CONSTANT.TYPE_CONFIRMATION,
			message: getI18NMessage( 'delete_confirmation' ),
			onConfirmFn: () => {
				that.deleteIC(icid);
			},
			onCancelFn: () => {
				that.setState({
					highlightIC: undefined
				});
			}
		}) );
	}
}

export default IssueListingView;